import * as ACTIONS from './language-action-creator';
import * as api from './language-api';
import {
  getFacilityInfo,
  getPatientFacilityInfo,
} from '../facility/facility-api';

const dispatchTranslations = (language, facilityId) => (dispatch) =>
  api.getTranslations(language, facilityId).then(
    (response) => dispatch(ACTIONS.translationsLoadedSuccess(response.data)),
    (axiosResponse) => {
      const error = axiosResponse.response;
      dispatch(ACTIONS.translationsLoadFailed(error));
    }
  );

const dispatchTranslationsFromPromise = (facilityPromise, languageCode, dispatch) => {
  facilityPromise.then((response) => {
    dispatch(dispatchTranslations(languageCode, response.data.facilityId));
  });
};

export const loadTranslations = (lang, inputFacilityId) => (dispatch, storeState) => {
  const sState = storeState() || { language: {} };
  let languageCode = lang;
  if (!languageCode) {
    languageCode = sState && sState.language ? sState.language.languageCode : null;
  }
  let facilityId = inputFacilityId;
  if (!facilityId) {
    facilityId = sState && sState.facility ? sState.facility.facilityId : null;
  }
  const patientId = sState && sState.profile && sState.profile.patient ? sState.profile.patient.patientId : null;

  if (facilityId) {
    return dispatch(dispatchTranslations(languageCode, facilityId));
  }

  if (patientId) {
    const facilityPromise = getPatientFacilityInfo(patientId);
    return dispatchTranslationsFromPromise(facilityPromise, languageCode, dispatch);
  }

  const facilityPromise = getFacilityInfo(document.URL);
  return dispatchTranslationsFromPromise(facilityPromise, languageCode, dispatch);
};

export const languageChange = (lang, callback) => (dispatch) => {
  dispatch(ACTIONS.changeLanguageState(lang));
  dispatch(loadTranslations(lang));
  if (callback) {
    callback();
  }
};

export const putPreferredLanguage = (userId, languageCode, reloadTranslations = true) => (dispatch) =>
  api.putPreferredLanguageApiCall(userId, languageCode)
    .then(
      () => {
        if (reloadTranslations) {
          dispatch(languageChange(languageCode));
        }
      }
    );

export const putPreferredLanguageByPatient = (patientId, languageCode) => (dispatch) =>
  api.putPatientPreferredLanguage(patientId, languageCode)
    .then(
      () => dispatch(languageChange(languageCode))
    );

export const loadLanguageTranslations = (langaugeCode) => (dispatch) =>
  api.getLanguageTranslations(langaugeCode)
    .then(
      (response) => {
        dispatch(ACTIONS.languageTranslationsLoaded(response.data));
      }
    );

export const loadPreferredLanguage = (patientId) => (dispatch) =>
  api.getPatientPreferredLanguage(patientId)
    .then(
      (response) => {
        dispatch(ACTIONS.changeLanguageState(response.data));
        dispatch(loadTranslations(response.data));
      }
    );
